import { useState } from "react";
import { X, Loader2, Send } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function InquiryModal({ open, onClose, targetType, targetId, targetName }) {
  const { user } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) return;
    setSending(true);
    try {
      await api.post("/inquiries", { target_type: targetType, target_id: targetId, name, email, phone, subject, message });
      toast.success(`Your message to ${targetName} was sent.`);
      setMessage(""); setSubject(""); setPhone("");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 z-[110] grid place-items-center px-4 bg-black/40 backdrop-blur-sm overflow-y-auto py-10" data-testid="inquiry-modal">
      <div className="relative w-full max-w-lg bg-[#F9F7F3] rounded-3xl shadow-2xl p-8 my-auto">
        <button onClick={onClose} data-testid="inquiry-close" className="absolute top-4 right-4 text-[#4A5D6B] hover:text-[#144F75]"><X size={20} /></button>
        <p className="eyw-label mb-1">Ask a Question</p>
        <h3 className="font-serif text-2xl text-[#1A242B] mb-1">Contact {targetName}</h3>
        <p className="text-sm text-[#4A5D6B] mb-5">No membership needed. Ask your question and you'll get a reply by email.</p>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid sm:grid-cols-2 gap-3">
            <input required value={name} onChange={(e) => setName(e.target.value)} data-testid="inquiry-name" className="eyw-input w-full" placeholder="Your name" />
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="inquiry-email" className="eyw-input w-full" placeholder="Email" />
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            <input value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="inquiry-phone" className="eyw-input w-full" placeholder="Phone (optional)" />
            <input value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="inquiry-subject" className="eyw-input w-full" placeholder="Subject (optional)" />
          </div>
          <textarea required rows={5} value={message} onChange={(e) => setMessage(e.target.value)} data-testid="inquiry-message" className="eyw-input w-full resize-none" placeholder="How can they help you?" />
          <button type="submit" disabled={sending} data-testid="inquiry-submit" className="eyw-btn w-full disabled:opacity-60">
            {sending ? <Loader2 className="animate-spin" size={16} /> : <Send size={15} />} Send question
          </button>
        </form>
      </div>
    </div>
  );
}
